module.exports = __webpack_public_path__ + "img/GOV_CE_LOGO_WHITE.f22a8fc7.svg";